// extracted by mini-css-extract-plugin
module.exports = {"container":"NeumoParagraph_container__G_F16","badge":"NeumoParagraph_badge__xzsKr","description":"NeumoParagraph_description__B9r4b"};